import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateACCentral } from '../../redux/ac_central/ac_central_actions';

const mapStateToProps = state => ({
  isDuplicating: state.ac.central.isDuplicating,
  errorMessage: state.ac.central.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateACCentral(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/ACCentralDuplicateModal.js